<template>
    <b-modal
        id="change-slu-course-banner-image-modal"
        ref="change-slu-course-banner-image-modal"
        size="md"
        :title="$t('slu_dashboard.change_course_banner')"
        :ok-title="$t('common.save')"
        modal-class="apprentice-default-modal change-slu-course-banner"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="onOk">
        <div class="change-slu-course-banner">
            <div
                class="slu-course-banner-preview"
                v-if="banner_preview !== null">
                <b-img :src="banner_preview"></b-img>
            </div>
            <div
                class="errors"
                v-if="hasErrors">
                <b-alert
                    v-for="(error, index) in errors"
                    v-if="error.error"
                    show
                    variant="danger"
                    :key="`error-${index}`"
                    >{{ error.message }}
                </b-alert>
            </div>
            <b-form-group
                class="slu-module-banner"
                :label="$t('slu_dashboard.image')"
                label-for="slu-module-banner-input">
                <template v-slot:label> {{ $t('slu_dashboard.image') }} <span class="required">*</span> </template>
                <b-form-file
                    class="apprentice-file-upload"
                    id="slu-module-banner-input"
                    v-model="file"
                    accept="image/jpeg,image/png"
                    :placeholder="$t('slu_dashboard.upload_banner')"
                    @change="showPreview"></b-form-file>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-slu-course-banner-upload-modal-component',
    props: ['sluCourseIn'],
    data() {
        return {
            file: null,
            banner_preview: null,
            errorsFound: false,
            errors: {
                banner: {
                    error: false,
                    message: this.$t('slu_dashboard.you_have_to_upload_a_banner'),
                },
            },
        };
    },
    methods: {
        onOk(bvModal) {
            if (this.hasErrors()) {
                bvModal.preventDefault();
                return;
            }
            const formData = new FormData();
            formData.append('file', this.file);

            const headers = { 'Content-Type': 'multipart/form-data' };
            this.alert.saving();
            axios.post(this.routes.sluCourseBanner(this.sluCourseIn.id), formData, { headers: headers }).then(
                (response) => {
                    this.$emit('updateCourse', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        showPreview(evt) {
            const file = evt.target.files[0];
            this.banner_preview = URL.createObjectURL(file);
        },

        hasErrors() {
            this.errorsFound = false;
            this.errors.banner.error = false;
            let errors = false;
            if (this.file === null || this.file === '') {
                this.errorsFound = true;
                this.errors.banner.error = true;
                errors = true;
            }

            return errors;
        },
    },
};
</script>

<style scoped lang="scss">
.slu-course-banner-preview {
    margin-bottom: $grid-gutter-width;

    img {
        object-fit: cover;
        object-position: center;
        width: 100%;
        height: 150px;
    }
}
</style>
